import { loadConfig } from './actions';
import configReducer from './reducer';

export { loadConfig, configReducer };
